module.exports = __webpack_public_path__ + "img/Kinoaktion.0c91515d.jpg";